import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "pb-2 text-left text-white" }

import { computed, inject, ref, watch } from 'vue'
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from '@headlessui/vue'
import { XCircleIcon } from '@heroicons/vue/outline'


export default /*#__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
  show: Boolean,
  message: String,
  success: Boolean,
  manual_close: Boolean,
  warning: Boolean
},
  emits: ['update:show'],
  setup(__props, { emit }) {

const props = __props

const showSync = computed({
  get: () => props.show,
  set: (value) => emit('update:show', value),
})

watch(showSync, () => {
  if (showSync && !props.manual_close) {
    setTimeout(() => (showSync.value = false), 2000)
  }
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass([__props.warning ? 'bg-yellow-500' : __props.success ? 'bg-green-500' : 'bg-red-500', "left-6 fixed bottom-6 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:align-middle max-w-md sm:w-full sm:p-2"])
                }, [
                  _createVNode(_Transition, {
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg leading-6 font-medium text-white"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.warning ? 'Warning' : __props.success ? 'Success' : 'Error'), 1)
                              ]),
                              _: 1
                            }),
                            (__props.manual_close)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createVNode(_unref(XCircleIcon), {
                                    class: "w-5 h-5 text-white cursor-pointer",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showSync.value = false))
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.message), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ], 2)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})